/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Indicates whether the data transfer was from a backup or restore operation. 
*/
export enum DataTransferOperationType {
  DATA_TRANSFER_OPERATION_TYPE_BACKUP = 'BACKUP',
  DATA_TRANSFER_OPERATION_TYPE_RESTORE = 'RESTORE'
}
